<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="24">
                <div class="bold fnt-lg dark text-left">
                    <div class="description">
                        Начало работы. Выберите раздел в левом меню
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
export default {
    name: 'StartPage'
};
</script>
